import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'bg-text-main-inversion mt-4 flex items-center justify-between gap-6 px-3 py-6 max-sm:flex-col max-sm:items-start sm:mt-6 sm:p-8',
    info: 'w-120 max-w-[65%] max-sm:w-full max-sm:max-w-full',
    title:
      'heading-m sm:heading-xl mb-2 leading-[140%] font-medium sm:font-medium sm:tracking-[.2px]',
    description:
      'sm:text-m text-xs leading-[140%] font-[300] sm:tracking-[.6px]',
    button: 'w-62 max-w-[30%] tracking-[1px] max-sm:w-full max-sm:max-w-full',
    line: 'block'
  }
});
